
function refreshLetterData() {
  return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(value => ({ value, class: 'unknown' }));
}

function getLetterClass(letterData, letter) {
  for(let i=0; i< letterData.length; i++) {
    if (letterData[i].value === letter) {
      return letterData[i].class;
    }
  }
  return 'unknown';
}

function setLetterClass(letterData, letter, letterClass) {
  for(let i=0; i< letterData.length; i++) {
    if (letterData[i].value === letter) {
      letterData[i].class = letterClass;
    }
  }
  return letterData;
}

function computeCells({ answer, guess, letterData }) {
  const exactMatches = guess.split('').map((letter, index) => {
    const letterClass = answer[index] === letter ? 'correct' : 'wrong';
    // in case of repeated letter, keep best value
    if (getLetterClass(letterData, letter) !== 'correct') {
      setLetterClass(letterData, letter, letterClass);
    }
    return {
      correctValue: answer[index],
      value: letter,
      index,
      class: letterClass
    };
  });
  let unmatchedAnswer = exactMatches.filter((x) => x.class === 'wrong').map((x) => x.correctValue).join('');
  return exactMatches.map((item) => {
    if (item.class === 'wrong' && unmatchedAnswer.indexOf(item.value) >= 0) {
      // update to letter to best match
      if (getLetterClass(letterData, item.value) == 'wrong') {
        setLetterClass(letterData, item.value, 'close');
      }
      // remove the letter from the unmatchedAnswer so it doesn't match again
      unmatchedAnswer = unmatchedAnswer.replace(item.value, '');
      return { ...item, class: 'close' };
    }
    return item;
  });
}

module.exports = {
  computeCells,
  getLetterClass,
  refreshLetterData
};
